import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { useConfig } from './configContext';
import { useVersion } from '../components/sidebar/useVersion';
import { useBasePath } from '@ais-ui/custom-hooks';
import { undefined } from 'zod';

export const useSentry = () => {
  const { config } = useConfig();
  const { version } = useVersion();

  useEffect(() => {
    if (!config.dsn) {
      console.warn('Sentry DSN is not configured. Skipping initialization.');
      return;
    }

    if (!config.sentryEnvironment) {
      console.warn(
        'Sentry environment is not configured. Skipping initialization.'
      );
      return;
    }

    const sentryConfig = {
      dsn: config.dsn,
      environment: config.sentryEnvironment,
      release: version,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: true,
          blockAllMedia: false,
        }),
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    };

    Sentry.init(sentryConfig);
  }, [config, version]);
};
